var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasFinished)?_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":"lock","size":"lg"},on:{"click":function($event){$event.stopPropagation();return _vm.closeEvent()}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }